import {stringify} from 'qs'
import request from 'crm/utils/request'
import api from './api'

// 获取-互动排行
export async function getTableList(payload) {
    return request(`${api.getTableList.url}?${stringify(payload?.params)}`)
}

// 导出数据
export async function exportData(payload) {
    return request(`${api.exportData.url}?${stringify(payload?.params)}`, null, {
        returnResponse: true,
    })
}
